import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { PuzzleFrameworkService } from 'projects/tools/src/lib/puzzle-framework-module/puzzle-framework.service';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ng2-tooltip-directive-major-angular-updates';

@Component({
  selector: 'lib-app-puzzle-button-custom',
  templateUrl: './puzzle-button-custom.component.html',
  styleUrls: ['../../../../../web/src/app/puzzle-screen/puzzle-screen.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, TranslateModule, TooltipModule],
})
export class PuzzleButtonCustomComponent implements OnInit {
  @Input() customID: number;

  public showTooltip = false;
  public showIcon = false;
  public showName = false;
  public showImage = false;

  public name: string;
  public icon: string;
  public image: string;

  private url: string;

  constructor(private translate: TranslateService, private framework: PuzzleFrameworkService) {}

  ngOnInit() {
    // {
    //   "show_name": false,
    //   "name": "Info",
    //   "show_icon": true,
    //   "icon": "insert_emoticon",
    //   "show_image": true,
    //   "image": "Demo/facebook.png",
    //   "show_tooltip": true,
    //   "url": "www.google.com"
    // }

    const customBtns = this.framework.puzzleFrameworkConfig.customButtons;

    // if (customBtns.count() < this.customID) {
    //   return;
    // }
    const customBtnInfo = customBtns[this.customID - 1];

    this.showTooltip = customBtnInfo.showTooltip;
    this.showIcon = customBtnInfo.showIcon;
    this.showName = customBtnInfo.showName;
    this.showImage = customBtnInfo.showImage;
    this.name = this.showName ? customBtnInfo.name : '';
    this.icon = this.showIcon ? customBtnInfo.icon : '';
    this.image = this.showImage ? customBtnInfo.image : '';
    this.url = customBtnInfo.url;
  }

  onBtnClicked() {
    window.open(this.url, '_blank');
  }
}
